// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reward-card[data-v-2ba3b9e2] {\n  --magic-header: var(--magic-light, #fff);\n  background-color: var(--magic-tertiary, #311261);\n  color: var(--magic-light, #fff);\n}\n\n.text[data-v-2ba3b9e2] {\n  font-size: 1rem;\n}\n\n.link[data-v-2ba3b9e2] {\n  --magic-text-primary: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
